import * as localizations from '~/api/models/localizations'
import * as alertRules from '~/api/models/alertRules'
import * as locations from '~/api/models/locations'
import * as schedules from '~/api/models/schedules'
import * as licences from '~/api/models/licences'
import * as licenceUsers from '~/api/models/licence-users'
import * as reportService from '~/api/models/report-service'
import * as dashboards from '~/api/models/dashboards'
import * as actions from '~/api/models/actions'
import * as routes from '~/api/models/routes'
import * as alerts from '~/api/models/alerts'
import * as groups from '~/api/models/groups'
import * as configurationPresets from '~/api/models/configurationPresets'
import * as assets from '~/api/models/assets'
import * as users from '~/api/models/users'
import * as views from '~/api/models/views'
import * as permissions from '~/api/models/permissions'
import * as plugins from '~/api/models/plugins'
import * as stateViewConfigs from '~/api/models/stateViewConfigs'
import type { Licence } from '~/types/licence'

interface Services {
  localizations: localizations.LocalizationService
  alertRules: alertRules.AlertRuleService
  locations: locations.LocationService
  schedules: schedules.ScheduleService
  licences: licences.LicenceService
  licenceUsers: licenceUsers.LicenceUsersModelService
  reportService: reportService.ReportServiceModelService
  dashboards: dashboards.DashboardsModelService
  actions: actions.ActionService
  routes: routes.RouteService
  alerts: alerts.AlertService
  groups: groups.GroupService
  configurationPresets: configurationPresets.ConfigurationPresetService
  assets: assets.AssetService
  users: users.UserService
  views: views.ViewService
  permissions: permissions.PermissionService
  plugins: plugins.PluginModelService
  stateViewConfigs: stateViewConfigs.StateViewConfigsModelService
}

export interface AuthArgs {
  isAuthenticated: Ref<boolean>
  activeLicence: Ref<Licence | undefined>
}

export const useServices = (): Services => {
  const authStore = useAuthStore()
  const { isAuthenticated, activeLicence } = storeToRefs(authStore)
  const authArgs: AuthArgs = {
    isAuthenticated,
    activeLicence
  }

  return {
    localizations: localizations.registerService(authArgs),
    alertRules: alertRules.registerService(authArgs),
    locations: locations.registerService(authArgs),
    schedules: schedules.registerService(authArgs),
    licences: licences.registerService(authArgs),
    licenceUsers: licenceUsers.registerService(authArgs),
    reportService: reportService.registerService(authArgs),
    dashboards: dashboards.registerService(authArgs),
    actions: actions.registerService(authArgs),
    routes: routes.registerService(authArgs),
    alerts: alerts.registerService(authArgs),
    groups: groups.registerService(authArgs),
    configurationPresets: configurationPresets.registerService(authArgs),
    assets: assets.registerService(authArgs),
    users: users.registerService(authArgs),
    views: views.registerService(authArgs),
    permissions: permissions.registerService(authArgs),
    plugins: plugins.registerService(authArgs),
    stateViewConfigs: stateViewConfigs.registerService(authArgs)
  }
}
